import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import { useLanguage } from '../../context/LanguageContext';

const PrivacePage = () => {
    const { t } = useLanguage();

    return (
        <Fragment>
            <SEO title={t('pages.privacy')} />
            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={t('pages.privacy')} pagesub={t('pages.privacy')} />
            <section className="pf-terms-section section-padding ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="pf-terms-wrap">
                                <div className="pf-terms-text">
                                    <h2>{t('privacy.title')}</h2>
                                    <h3>{t('privacy.h1')}</h3>
                                    <p><strong>{t('privacy.p1_1')}</strong></p>
                                    <p><strong>{t('privacy.p1_2')}</strong></p>
                                    <h3>{t('privacy.h2')}</h3>
                                    <p>{t('privacy.p2')}</p>
                                    <ul>
                                        <li>{t('privacy.li2_1')}</li>
                                        <li>{t('privacy.li2_2')}</li>
                                        <li>{t('privacy.li2_3')}</li>
                                        <li>{t('privacy.li2_4')}</li>
                                        <li>{t('privacy.li2_5')}</li>
                                    </ul>
                                    <h3>{t('privacy.h3')}</h3>
                                    <p>{t('privacy.p3')}</p>
                                    <h3>{t('privacy.h4')}</h3>
                                    <p>{t('privacy.p4')}</p>
                                    <ul>
                                        <li>{t('privacy.li4_1')}</li>
                                        <li>{t('privacy.li4_2')}</li>
                                        <li>{t('privacy.li4_3')}</li>
                                    </ul>
                                    <h3>{t('privacy.h5')}</h3>
                                    <p>{t('privacy.p5')}</p>
                                    <h3>{t('privacy.h6')}</h3>
                                    <p>{t('privacy.p6')}</p>
                                    <h3>{t('privacy.h7')}</h3>
                                    <p>{t('privacy.p7')}</p>
                                    <h3>{t('privacy.h8')}</h3>
                                    <p>{t('privacy.p8')}</p>
                                    <h3>{t('privacy.h9')}</h3>
                                    <p>{t('privacy.p9')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PrivacePage;
